var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeviceWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.975 13.0209C10.9811 15.4196 10.9883 19.495 10.9943 22.6625C15.3311 23.249 19.668 23.8536 23.9976 24.5C23.9976 20.7185 24.0024 16.9535 23.9976 13.3555C19.6571 13.3555 15.3179 13.0209 10.975 13.0209ZM0 13.0221V21.166C3.27098 21.6074 6.54195 22.0292 9.80692 22.5113C9.81293 19.3607 9.80451 16.2091 9.80451 13.0584C6.53594 13.0644 3.26857 13.0113 0 13.0221ZM0 3.91191V12.033C3.27098 12.0414 6.54195 11.9919 9.81293 11.9955C9.81053 8.85204 9.81053 5.71242 9.80692 2.56895C6.53353 2.97792 3.26015 3.41059 0 3.91191ZM24 11.866C19.6656 11.8828 15.3311 11.9489 10.9943 11.9621C10.9919 8.76706 10.9919 5.57584 10.9943 2.3832C15.3227 1.72236 19.6608 1.10086 23.9976 0.5C24 4.28991 23.9976 8.0761 24 11.866Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceWindows);
export default __webpack_public_path__ + "static/media/device-Windows.78895e55cd9b5b8308c592a412f1bd86.svg";
export { ForwardRef as ReactComponent };